import {GET_VEHICLES_IDLES_SUCCESS, GET_VEHICLES_LOCATIONS_SUCCESS, GET_VEHICLES_SUCCESS} from "./vehicles.types";

const initialState = {
  vehiclesList: null,
  vehiclesIdlesList: null,
  vehiclesLocations: null,
};

export const vehiclesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VEHICLES_SUCCESS:
      return {
        ...state,
        vehiclesList: action.payload,
      };

      case GET_VEHICLES_IDLES_SUCCESS:
      return {
        ...state,
        vehiclesIdlesList: action.payload,
      };

      case GET_VEHICLES_LOCATIONS_SUCCESS:
      return {
        ...state,
        vehiclesLocations: action.payload,
      };

    default:
      return state;
  }
};
